module.exports = __webpack_public_path__ + "img/Menu-12.cb576af4.png";